<template>
  <div class="yk-home">
    <div class="banner">
      <el-carousel indicator-position="inside" :height="bannerHeight">
        <el-carousel-item v-for="(item, index) in imgList" :key="'banner'+index">
          <img class="image" :alt="item.title" width="100%" height="auto" :title="item.title" :src="item.pic" @click="clickBanner(item)">
        </el-carousel-item>
      </el-carousel>
      <div class="new" :style="`top:${newsTop}`">
        <img class="img" src="../../assets/images/home/6.png">
        <p class="title1">最新动态</p>
        <p class="title2">{{newsInfo.title}}</p>
        <p class="string" id="newssummarys">{{summarys}}</p>
        <p class="moreBtn" @click="goNews()">{{$t('home.more')}} > ></p>
        <div class="listBox">
          <div class="item" v-for="(item, index) in dataList" :key="'item'+index" @click="clickAbout(item)">
            <i :class="item.class"></i>
            <p class="name">{{item.name}}</p>
          </div>
        </div>
      </div>
    </div>
    <div class="about">
      <p class="title">{{aboutName}}</p>
      <p class="content">
        永康乐业致力于成为<label>先进生物制造领域</label>的全球领导者，为<label>医疗器械</label>和<label>生物医疗</label>领域提供包括设备、材料、测试评价和技术服务在内的整体解决方案
      </p>
    </div>
    <div class="adList">
      <div class="item" v-for="(item, index) in adList" :key="'adList'+index" >
        <img class="img" :alt="item.title" :title="item.title" :src="item.pic" @click="clickBanner(item)">
      </div>
    </div>
    <div class="expand">
      <p class="title">{{ extName }}</p>
      <p class="subtitle">{{ extBarBrief }}</p>
      <div class="itemList">
        <div class="item" v-for="(item, index) in expandList" :key="'expand'+index" :class="item.class" @click="clickService(item)">
          <img class="img" :alt="item.alt" :title="item.alt" :src="item.img">
          <p class="name">{{item.name}}</p>
          <p class="subString">{{item.text}}</p>
        </div>
      </div>
    </div>
    <div class="solution" v-if="showSolution">
      <p class="title">{{ solutionName }}</p>
      <p class="subtitle">{{ solutionBarBrief }}</p>
      <div class="swiperBox">
        <div class="swiper-button-prev" slot="button-prev"></div>
        <div class="swiper-button-next" slot="button-next"></div>
        <swiper class="listItemBox" ref="swiperRef_1" :options="swiperOption_1" v-if="solutionList.length > 0">
          <swiper-slide v-for="(item, index) in solutionList" :key="'solution'+index" class="itemBox">
            <div @click="clickSolution(item)">
              <div class="bgImg">
                <img class="img" :alt="item.alt" :title="item.alt" :src="item.img">
              </div>
              <div class="textBox" :class="`bgColor${index%4}`">            
                <p class="name">{{item.name}}</p>
                <p class="subString">{{item.text}}</p>
                <i class="iconAdd"></i>
              </div>
            </div>            
          </swiper-slide>
        </swiper>
      </div>
    </div>
    <div class="mapBox">
      <baidu-map class="baiduMap" :center="{lng: 116.339977, lat: 39.702968}" :scroll-wheel-zoom="true" :zoom="16">
        <bm-marker
          :position="{lng: 116.339977, lat: 39.702968}"
          :dragging="true"
          title="北京市大兴区庆祥北路3号院金隅高新产业园"
          :zIndex="999999999"
          :icon="{ url: markerIcon, size: { width: 26, height: 33 } }"
        >
        <bm-info-window :show="true">金隅高新产业园</bm-info-window> 
        </bm-marker>       
      </baidu-map>
      <div class="us">
        <p class="title">关注我们</p>
        <p class="title1">获得及时的服务与资讯内容</p>
        <div class="list">
          <img :src="require('../../assets/images/contact/weixin.png')" @mouseover="showQrcode=true" @mouseout="showQrcode=false">
          <img v-for="(item, index) in linkList" :key="'link'+index" :src="item.img" @click="clickLink(item)">
        </div>
        <div class="qrcode" v-show="showQrcode">
          <img :src="require('../../assets/images/home/qrcode.jpg')">
        </div>
      </div>
    </div>
    <div class="bottomLogo">
      <img :src="require('../../assets/images/home/home_bottom.jpg')">
    </div>
  </div>
</template>
<script>
import BmMarker from "vue-baidu-map/components/overlays/Marker"; //点标注
import BmInfoWindow from "vue-baidu-map/components/overlays/InfoWindow";
export default {
  data () {
    return {
      dataList: [
        {name: '发展历程', class: 'img1'},
        {name: '核心技术', class: 'img2'},
        {name: '人员团队', class: 'img3'},
        {name: '品牌建设', class: 'img4'},
        {name: '合作案例', class: 'img5'},
      ],
      newsInfo: {},
      expandList: [
        {id: '0',  img: require('../../assets/images/home/1-sbdzh.jpg'), alt: ''},
        {id: '1',  img: require('../../assets/images/home/2-cpdg.jpg'), alt: ''},
        {id: '2',  img: require('../../assets/images/home/3-fxjc.jpg'), alt: ''},
        {id: '3',  img: require('../../assets/images/home/4-gyts.jpg'), alt: ''},
      ],
      solutionList: [
        {name: '组织工程', text: 'Tissue engineering', img: require('../../assets/images/home/1-zzgc.jpg'), alt: ''},
        {name: '药物释放', text: 'Drug release', img: require('../../assets/images/home/2-ywsf.jpg'), alt: ''},
        {name: '医疗器械', text: 'Medical instrument', img: require('../../assets/images/home/3-ylqx.jpg'), alt: ''},
        {name: '细胞培养', text: 'Cell culture', img: require('../../assets/images/home/4-xbpy.jpg'), alt: ''},
        {name: '分析检测', text: 'Analysis and detection', img: require('../../assets/images/home/5-fxjc.jpg'), alt: ''},
        {name: '原料合成', text: 'Material synthesis', img: require('../../assets/images/home/6-ylhc.jpg'), alt: ''},
        {name: '生物表面改性', text: 'Biological surface modification', img: require('../../assets/images/home/7-swbm.jpg'), alt: ''},
        {name: 'CRO', text: 'Biological clinical trial', img: require('../../assets/images/home/8-CR0.jpg'), alt: ''},
      ],
      showSolution: false,
      swiperOption_1: {
        slidesPerView: 4,
        // spaceBetween: 30,
        pagination: '.swiper-pagination',
        paginationType: 'fraction',
        observeParents: true,
        observer: true,
        // 设置前进后退按钮
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        // 设置自动轮播
        autoplay: { 
          delay: 3000,
          disableOnInteraction: false,
        },
        loop: true,
        on: {},
      },
      imgList: [],
      adList: [],
      summarys:'',
      markerIcon: require('../../assets/images/contact/p.png'),      
      linkList: [
        {img: require('../../assets/images/contact/bzhan.png'), link: 'https://space.bilibili.com/1753820548?spm_id_from=333.337.search-card.all.click'},
        {img: require('../../assets/images/contact/zhihu.png'), link: 'https://www.zhihu.com/people/yong-kang-le-ye'},
        {img: require('../../assets/images/contact/baijia.png'), link: 'http://baijiahao.baidu.com/u?app_id=1548677563431475'},
      ],
      showQrcode: false,
      bannerHeight:null,
      newsTop:null,
      solutionName:"解决方案",
      solutionBarBrief:"解决方案简介",
      extName:"拓展服务",
      extBarBrief:"拓展服务简介",
      aboutName:"关于我们",
      aboutBarBrief:"关于我们简介",
    }
  },
  mounted () {
    this.getData()
  },
  methods: {
    getData () {
      this.$get(`/api/navigation`).then(res => {
        if (res.code === 0) {
          let solution = res.data.find(val => {return val.typeLabel === 'solution'})
          if (solution && solution.children.length > 0) {
            this.solutionName = solution.name;
            this.solutionBarBrief = solution.barBrief;
            solution.children.map((val, idx) => {
              let obj = this.solutionList[idx]
              obj.id = val.id
              obj.name = val.name
              obj.text = val.barBrief
              obj.alt = val.barBrief            
           })
            this.showSolution = true
          }
          let ext = res.data.find(val => {return val.typeLabel === 'ext-service'})
          if (ext && ext.children.length > 0) {
            this.extName = ext.name;
            this.extBarBrief = ext.barBrief;

            ext.children.map((val, idx) => {
            if (idx < 4) {
              let obj = this.expandList[idx]
              obj.id = val.id
              obj.name = val.name
              obj.text = val.barBrief
              obj.alt = val.barBrief
            }            
           })
          }
          let about = res.data.find(val => {return val.typeLabel === 'about'})
          if (about && about.children.length > 0) {
            if(about.name != undefined){
              this.aboutName = about.name;
            }
            if(about.barBrief != undefined){
              this.aboutBarBrief = about.barBrief;
            }

            about.children.map((val, idx) => {
              let obj = this.dataList[idx]
              obj.id = val.id
              obj.name = val.name                       
           })
          }
        }
      }),
    
      this.$get(`/api/home`).then(res => {
        if (res.code === 0) {
          this.imgList = res.data.bannerList || []
          this.adList = res.data.adList || []
          this.newsInfo = res.data.latestNew || {}
          if(this.newsInfo.summarys != undefined && this.newsInfo.summarys != null){
              if(this.newsInfo.summarys.length > 100){
                this.summarys = this.newsInfo.summarys.substr(0,100);
              }else{
                this.summarys = this.newsInfo.summarys;
              }
          }
          this.$nextTick(() => {
            this.getTopHeight()
          })
        }
      })    
    },
    getTopHeight () {
      this.bannerHeight = this.pageWidth *537/1920 +"px";
      if(this.pageWidth < 900){
        this.newsTop = this.bannerHeight;
      }else{
        this.newsTop = this.pageWidth *537/1920 -200 +"px";
      }
    },
    goNews () {
      if (this.newsInfo.id) {
        this.$router.push({
          path: '/newsDetail',
          query: {newsId: this.newsInfo.id}
        })
      }      
    },
    clickLink (item) {
      window.open(item.link, '_self')
    },
    clickSolution (item) {
      if (item.id) {
        this.$router.push({path: '/solution',query: {solutionId: item.id}})
      }
    },
    clickService (item) {
      if (item.id) {
        this.$router.push({path: '/ext-service',query: {extId: item.id}})
      }
    },
    clickAbout (item) {
      this.$router.push({path: '/about', query: {name: item.name}})
    },
    clickBanner (item) {     
      window.open(item.address,'_self')
    },
  },
  watch: {
    pageWidth () {
      this.getTopHeight()
    }
  },
  beforeDestroy () {
  },
  components: {BmMarker, BmInfoWindow},
}
</script>
<style scoped lang="stylus">
.yk-home
  width 100%
  color $c1
  .banner
    background-color #F1F1F5
    position relative
    .image  
      cursor pointer
    .new
      top $pageWidth
      height 400px
      width 670px
      position absolute
      right calc((100% - 1430px) / 2)
      padding 50px 50px 20px 50px
      border-radius 50px
      background-color $c7
      z-index 2
      .img
        position absolute
        right 0
        top -130px
        cursor pointer
        width auto
        display block
      .title1
        font-size 26px
        font-weight 600
        margin-bottom 35px
      .title2
        font-size 20px
        line-height 36px
        margin-bottom 18px
        -webkit-line-clamp: 2;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
      .string
        color $c2
        width 510px
        font-size 18px
        line-height 30px
        margin-bottom 18px
        -webkit-line-clamp: 2;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
      .moreBtn
        font-size 18px
        color $c4
        cursor pointer
      .listBox
        display flex
        height 100px
        margin-top 50px
        .item
          flex 1
          text-align center
          cursor pointer
          i
            display block
            width 85px
            height 85px
            margin 0 auto 20px auto
            background-size cover
          .img1
            background-image url('../../assets/images/home/1.png')
          .img2
            background-image url('../../assets/images/home/2.png')
          .img3
            background-image url('../../assets/images/home/3.png')
          .img4
            background-image url('../../assets/images/home/4.png')
          .img5
            background-image url('../../assets/images/home/5.png')
          .name
            font-size 22px
  .about
    width $pageWidth
    margin 0 auto 40px auto
    .title
      font-size 32px
      font-weight 600
      margin 60px 0 20px 0
    .content
      width 700px
      font-size 24px
      line-height 50px
      label
        color $c8
  .adList
    width $pageWidth
    margin 0 auto
    cursor pointer
    .item
      overflow:hidden;
      margin-bottom 20px
      &:hover
          .img
            animation imgBig 0.6s ease forwards
      img
        width 100%
        animation imgNormal 0.6s ease forwards
  .expand, .solution
    text-align center
    margin 70px 0
    .title
      font-size 60px
      font-weight 600
      margin-bottom 28px
    .subtitle
      font-size 30px
      margin-bottom 90px
  .expand
    .itemList
      display flex
      height 39vw
      .item
        color $c7
        flex 1
        background-size cover
        display flex
        justify-content center
        flex-direction column
        position relative
        overflow hidden
        cursor pointer
        &:hover
          .img
            animation imgBig 0.6s ease forwards
        .img
          width 100%
          position absolute
          top 0
          left 0
          animation imgNormal 0.6s ease forwards
        .name
          font-size 36px
          font-weight 600
          margin 40px 0 20px 0
          z-index 1
        .subString
          width 50%
          margin 0 auto
          font-size 20px
          line-height 26px
          z-index 1
          white-space pre-line
          word-break: break-all
  .solution    
    .swiperBox
      position relative
      margin 0 auto
      width $pageWidth
      height 480px
      // overflow hidden
      .listItemBox
        height 100%
        cursor pointer
        .itemBox
          height 100%
          position relative
          .bgImg
            overflow hidden
            width 346px
            height 410px
            position relative
            .img
              position absolute
              left 0
              top 0
              width 100%
            &:hover
              .img
                animation imgBig 0.6s ease forwards
          .textBox
            width 255px
            height 225px
            position absolute
            z-index 1
            bottom 20px
            left 50%
            transform translate3d(-50%, 0, 0)
            display flex
            flex-direction column
            justify-content center
            color $c7
            padding 20px
            .name
              font-size 24px
              margin-bottom 20px
              font-weight 600
            .subString
              font-size 18px
              line-height 24px
              margin-bottom 20px
              white-space pre-line
              word-break: break-all
            .iconAdd
              width 38px
              height 38px
              margin 20px auto 0 auto
              background-image url('../../assets/images/home/add.png')
          .bgColor0
            background-color rgba(9,81,157,0.73)
          .bgColor1
            background-color rgba(1,159,131,0.73)
          .bgColor2
            background-color rgba(51,193,205,0.73)
          .bgColor3
            background-color rgba(245,127,23,0.73)
      .swiper-button-prev, .swiper-button-next
        position absolute
        top 40%
        width 35px
        height 68px
      .swiper-button-prev
        left -5%
        background-image url('../../assets/images/home/l.png')
      .swiper-button-next
        right -5%
        background-image url('../../assets/images/home/r.png')
  .mapBox
    margin 0 auto
    width $pageWidth
    position relative
    .baiduMap
      width 70%
      height 444px
    .us
      position absolute
      right 0
      top 40px
      width 765px
      height 308px
      padding 40px 60px 40px 60px
      color $c7
      background-image url('../../assets/images/home/15.png')
      .title
        font-size 40px
        margin-bottom 20px
      .title1
        font-size 30px
        margin-bottom 28px
      .list
        display flex
        img
          width 20%
          margin 0 2.5%
          cursor pointer
      .qrcode
        position absolute
        bottom -70%
        left 10%
        width 30%
        img
          width 100%
  .bottomLogo
    margin-top 50px
    img
      width 100%

@keyframes imgBig
  0%
    transform scale(1)
  100%
    transform scale(1.1)
@keyframes imgNormal
  0%
    transform scale(1.1)
  100%
    transform scale(1)
@media screen and (max-width: 1440px)
  .yk-home
    .banner
      .new
        height 300px
    .expand
      .itemList
        height 570px
@media screen and (max-width: 900px)
  .yk-home
    .banner
      background-color #E5EBF1
      .new
        width 94%
        height 12rem
        left 3%
        padding 1.6rem 1rem
        bottom -160px
        .img
          transform scale(0.6)
          transform-origin right center
          display none
        .title1
          font-size 1rem
          margin-bottom 1.3rem
        .title2
          font-size 0.8rem
          margin-bottom 10px
        .string
          width 100%
          font-size 0.7rem
          line-height 1.2rem
        .moreBtn
          font-size 0.7rem
        .listBox
          cursor pointer
          margin-top: 1rem
          .item
            i
              width 2.8rem
              height 2.8rem
            .name
              font-size 0.7rem
    .about
      width 100%
      margin-top 20rem
      .title
        text-align center
        font-size 1.6rem
        margin-bottom 0.6rem
      .content
        width 100%
        padding 0 4%
        font-size 0.8rem
        line-height 2rem    
    .adList
      width 100%
    .expand, .solution
      margin-top 1rem
      .title
        font-size 1.6rem
        margin-bottom 10px
      .subtitle
        font-size 0.8rem
        margin-bottom 1.5rem
    .expand
      .itemList
        height auto
        flex-wrap wrap
        padding 0 3%
        .item
          flex none
          width calc(50% - 1.5%)
          height 46vw
          border-radius 10px
          overflow hidden
          &:nth-of-type(2n + 1)
            margin 0 3% 3% 0
          .name
            font-size 1rem
            margin 1rem 0
            position relative
            &:before
              content ''
              position absolute
              left 50%
              bottom -0.5rem
              display block
              width 40%
              border-bottom 1px solid rgba(255,255,255,0.5)
              transform translate3d(-50%, 0, 0)
          .subString
            width 80%
            font-size 0.6rem
            line-height 1rem
    .solution
      margin 0
      .swiperBox
        height 480px
        transform scale(0.7)
        transform-origin left top

    .mapBox
      margin-top -3rem
      width 100%
      .baiduMap
        width 100%
        height 15rem
        margin-bottom 8rem
      .us
        width 100%
        padding 0
        right 0
        top 110%
        transform-origin right top
        background-image none
        color $c1
        text-align center
        .title
          font-size 1.2rem
        .title1
          font-size 0.9rem
        .list
          justify-content space-around
        .qrcode
          bottom -5rem
    .bottomLogo
      .box
        width 100%
      .logo
        font-size 2rem
        padding 20px 1rem 1rem 1rem
      .text
        font-size 0.7rem
        padding-left 1rem
@media screen and (max-width: 700px)
  .yk-home
    .new
     height 12rem
    .about
    .solution
      .swiperBox
        transform scale(0.6)
    .mapBox
      margin-top -8rem
      .baiduMap
        margin-bottom 10rem
      .us
        .title1
          margin-bottom 0.5rem
        .qrcode
          bottom calc(10% - 4rem)
@media screen and (max-width: 600px)
  .yk-home
   .new
     height 11rem
   .about
    .mapBox
      .us
        .qrcode
          bottom calc(20% - 4rem)
@media screen and (max-width: 500px)
  .yk-home
    .new
      height 10rem
    .about
    .mapBox
      .us
        .qrcode
          bottom calc(30% - 4rem)
@media screen and (max-width: 400px)
  .yk-home
    .banner
      .new
        height 40%
    .about
      .title
        margin-top 3rem
    .solution
      .swiperBox
        transform scale(0.5)
    .mapBox
      margin-top -9rem
      .baiduMap
        margin-bottom 12rem
      .us
        .qrcode
          bottom calc(50% - 4rem)
</style>